export default "/images/site-logo.png?1c408dce67d72bc29ee6ace7d0fbc941";